import { AnnotationPluginKey } from './AnnotationPlugin.js';

class AnnotationMeta {
  constructor(hoveredAnnotationId, focusedAnnotationId, commentId) {
    this.hoveredAnnotationId = null;
    this.focusedAnnotationId = null;
    this.commentId = null;
    this.hoveredAnnotationId = hoveredAnnotationId;
    this.focusedAnnotationId = focusedAnnotationId;
    this.commentId = commentId;
  }
  static setAnnotationState(view, hoveredAnnotationId, focusedAnnotationId, commentId) {
    const annotationMeta = new AnnotationMeta(hoveredAnnotationId, focusedAnnotationId, commentId);
    const tr = view.state.tr.setMeta(AnnotationPluginKey, annotationMeta);
    view.dispatch(tr);
  }
}

export { AnnotationMeta };
//# sourceMappingURL=AnnotationMeta.js.map
